import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { localGet } from './utils/localStorage';

const supportedLanguages = ['en_US', 'pt_PT', 'de_DE'];
const defaultLanguage = 'en_US';

const currentLanguage = () => {
  let lang = localGet('lang', defaultLanguage);
  if (typeof lang !== 'string' || !supportedLanguages.includes(lang)) {
    lang = defaultLanguage;
  }
  return lang;
};

i18n
  .use(Backend)
  .init({
    whitelist: supportedLanguages,
    fallbackLng: currentLanguage(),

    ns: ['translations'],
    defaultNS: 'translations',

    debug: true,

    react: {
      wait: true,
    },
  });

export default i18n;
export { currentLanguage, defaultLanguage, supportedLanguages };



// WEBPACK FOOTER //
// ./src/i18n.js